<template>
  <div>
    <header class="header">
      <img
        src="@/assets/img/logo_fqm_branco.svg"
        alt="Logo"
        @click="goToRoute('Solicitacoes')"
      />
      <v-icon @click.stop="drawer = !drawer" color="white" class="ma-2"
        >mdi-menu</v-icon
      >
    </header>
    <v-navigation-drawer v-model="drawer" absolute right temporary class="pa-2">
      <nav class="nav">
        <ul>
          <div v-for="(link, index) in links" :key="index">
            <li
              v-if="
                checkPermission(link.permission) 
                && link.excludeTypePermission !== isRepresentante
                && customEnabled(link.customEnabled)
              "
            >
              <v-list-group
                v-if="link.children.length"
                :value="true"
                color="fmq_black"
              >
                <template v-slot:activator>
                  <v-list-item-title>{{ link.title }}</v-list-item-title>
                </template>
                <v-list
                  v-for="(child, index) in link.children"
                  :key="index"
                  class="pa-0"
                >
                  <v-list-item
                    v-if="checkPermissionChild(child)
                      && customEnabled(child.customEnabled)"
                    link
                    class="pl-6"
                    :disabled="child.route === routeName"
                  >
                    <v-list-item-title @click="goToRoute(child.route)">{{
                      child.title
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-group>
              <v-list-item v-else @click="goToRoute(link.route)">{{
                link.title
              }}</v-list-item>
            </li>
          </div>
        </ul>
      </nav>
      <v-btn
        class="ma-2"
        color="fmq_black"
        outlined
        solo
        width="220px"
        @click="
          $emit('logout');
          loading = true;
        "
        :loading="loading"
      >
        Sair <v-icon right> mdi-exit-to-app </v-icon></v-btn
      >
    </v-navigation-drawer>
  </div>
</template>

<script>
import { checkPermission } from "@/utils";
export default {
  name: "HeaderMobile",
  props: {
    links: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    drawer: false,
    loading: false,
  }),
  methods: {
    customEnabled(customEnabled) {
      let returnChecking = true;

      if (customEnabled === undefined || customEnabled === null || customEnabled === "") {
        return returnChecking;
      }
      customEnabled.forEach(element => {
        let checking = true;
        switch (element) {

          case 'notAccessibleToColaborador':
            checking = this.notAccessibleToType('Colaborador');
              if (!checking) {
                returnChecking = false;
              }
            break;

          case 'notAccessibleToAdmMesa':
            checking = this.notAccessibleToType('Administrador de mesa');
              if (!checking) {
                returnChecking = false;
              } 
            break;
        }
      });
      return returnChecking;
    },
    checkPermission,
    checkPermissionChild(child) {
      if (child.mesaId && child.excludeTypePermission.length > 0 && this.roleUser !== "Administrador master") {
        return (
          this.checkPermission(child.permission) &&
          child.excludeTypePermission.includes(this.roleUser) &&
          child.mesaId === this.mesaId
        );
      } else {
        return this.checkPermission(child.permission);
      }
    },
    goToRoute(route) {
      this.$router.push({ name: route });
    },
    
    notAccessibleToType(userType) {
      /* console.log(this.roleUser);
      console.log(this.userType);
      console.log(this.roleUser !== userType); */
      return this.roleUser !== userType;
    },
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    isRepresentante() {
      return this.$store.state.user.data.tipo;
    },
    roleUser() {
      return this.$store.state.user.data.tipo;
    },
    mesaId() {
      return this.$store.state.user.data.funcionario.mesaId;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #343a40;
  img {
    max-width: 100px;
    cursor: pointer;
  }
}
.nav {
  ul {
    list-style: none;
    padding: 0;
  }
}
</style>
